import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * CDP (Média HLC e Desvios, FML.CDP) — overlay de preço, 5 linhas:
 * CDP (média HLC) + AH/AL (desvios pela amplitude anterior) + NH/NL.
 * yAccessor(d) retorna { cdp, ah, al, nh, nl }.
 */
const LINES = [
  ["cdp", "strokeCdp"],
  ["ah", "strokeAh"],
  ["al", "strokeAl"],
  ["nh", "strokeNh"],
  ["nl", "strokeNl"],
];

class CDPSeries extends Component {
  constructor(props) {
    super(props);
    // Um accessor por linha, criado uma única vez (nada de closure em render).
    this.accessors = LINES.reduce((acc, [key]) => {
      acc[key] = (d) => {
        const v = this.props.yAccessor(d);
        return v && v[key];
      };
      return acc;
    }, {});
  }
  render() {
    const { className } = this.props;
    return (
      <g className={className}>
        {LINES.map(([key, strokeProp]) => (
          <LineSeries
            key={key}
            yAccessor={this.accessors[key]}
            stroke={this.props[strokeProp]}
            fill="none"
          />
        ))}
      </g>
    );
  }
}

const strokeType = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);

CDPSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeCdp: strokeType,
  strokeAh: strokeType,
  strokeAl: strokeType,
  strokeNh: strokeType,
  strokeNl: strokeType,
  className: PropTypes.string,
};

// Paleta default do engine, por ÍNDICE de série (FormulaBase.DefaultColors).
CDPSeries.defaultProps = {
  strokeCdp: { color: "#FFFF00" },
  strokeAh: { color: "#FF0000" },
  strokeAl: { color: "#0000B4" },
  strokeNh: { color: "#A9A9A9" },
  strokeNl: { color: "#1E90FF" },
  className: "react-stockcharts-cdp-series",
};

export default CDPSeries;
